import { render, staticRenderFns } from "./commonDateSelectNew.vue?vue&type=template&id=bc052214&scoped=true"
import script from "./commonDateSelectNew.vue?vue&type=script&lang=js"
export * from "./commonDateSelectNew.vue?vue&type=script&lang=js"
import style0 from "./commonDateSelectNew.vue?vue&type=style&index=0&id=bc052214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc052214",
  null
  
)

export default component.exports